import React from 'react';
import { useFormikContext } from 'formik';
import { useToasts } from 'react-toast-notifications';
import { Button } from '@material-ui/core';
import api from '../api';
import { useAppData } from '../contexts/appContext';
import useFortifySigning from './useFortifySigning';

function FileInvoiceButton() {
	const { config } = useAppData();
	const { addToast } = useToasts();
	const { values, setFieldValue } = useFormikContext();
	const { requestSignature, signingDialog } = useFortifySigning({
		onSigned: signature =>
			api
				.post(`/api/fileinvoice/${values.id}`, {
					signature
				})
				.then(res => {
					const { data } = res;
					setFieldValue('etaInvoiceId', data.etaInvoiceId);
					setFieldValue('invoiceStatus', data.invoiceStatus);
					addToast('E-Invoice Filed', {
						appearance: 'success',
						autoDismiss: true
					});
				})
	});
	const onFileClick = () => {
		if (config.features.etaReceipt && values.partyType === 'client') {
			return api.post(`/api/filereceipt/${values.id}`).then(res => {
				const { data } = res;
				addToast('e-Receipt Filed', {
					appearance: 'success',
					autoDismiss: true
				});
				setFieldValue('etaReceiptId', data.etaReceiptId);
				setFieldValue('etaReceiptStatus', data.etaReceiptStatus);
			});
		}
		if (config.etaConfig.serverSigning)
			api.post(`/api/fileinvoice/${values.id}`).then(res => {
				const { data } = res;
				addToast('E-Invoice Filed', {
					appearance: 'success',
					autoDismiss: true
				});
				setFieldValue('etaInvoiceId', data.etaInvoiceId);
				setFieldValue('invoiceStatus', data.invoiceStatus);
			});
		else
			api.get(`/api/gov-invoice/${values.id}`).then(res => {
				const { data } = res;
				const { serializedInvoice } = data;
				requestSignature(serializedInvoice);
			});
	};
	const onCancelClick = () => {
		api.post(`/api/cancelinvoice/${values.id}`).then(res => {
			const { data } = res;
			addToast('Canceled E-Invoice', {
				appearance: 'success',
				autoDismiss: true
			});
			setFieldValue('etaInvoiceId', data.etaInvoiceId);
			setFieldValue('invoiceStatus', data.invoiceStatus);
		});
	};

	const onReturnClick = () => {
		api.post(`/api/filereturnreceipt/${values.id}`).then(res => {
			const { data } = res;
			addToast('Filed Return e-Receipt', {
				appearance: 'success',
				autoDismiss: true
			});
			setFieldValue('etaReturnReceiptId', data.etaReturnReceiptId);
			setFieldValue('etaReturnReceiptStatus', data.etaReturnReceiptStatus);
		});
	};

	if (values.etaInvoiceId) {
		return (
			<Button onClick={onCancelClick} variant="contained">
				Cancel E-Invoice
			</Button>
		);
	}
	if (values.etaReceiptId) {
		return (
			<Button onClick={onReturnClick} variant="contained">
				File Return e-Receipt
			</Button>
		);
	}
	if (values.etaReceiptId && values.etaReturnReceiptId) return <></>;
	return (
		<>
			<Button onClick={onFileClick} variant="contained" color="primary">
				{config.features.etaReceipt && values.partyType === 'client'
					? 'File e-Receipt'
					: 'File E-Invoice'}
			</Button>
			{signingDialog}
		</>
	);
}

export default FileInvoiceButton;
